export const PASSWORD_POLICIES: { [key: number]: PasswordPolicy } = {
    1: {
        id: 1,
        pattern: /.{8,}/,
        text: 'Password must be at least 8 characters long.'
    },
    2: {
        id: 2,
        pattern: /(?=.*[a-z])(?=.*[A-Z]).{8,}/,
        text: 'Password must be at least 8 characters long and contain both lowercase and uppercase letters.'
    },
    3: {
        id: 3,
        pattern: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{8,}/,
        text: 'Password must be at least 8 characters long, contain both lowercase and uppercase letters, at least one digit and one of the characters @ # $ %.'
    },
    4: {
        id: 4,
        // `_` is an accepted special character, `-` is not: the previous `\\-_` was a range from `\` to `_`, not a hyphen
        pattern: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@%+\\/'!#$^?:.(){}[\]~`_]).{8,}/,
        text: 'Password must be at least 8 characters long, contain both lowercase and uppercase letters, at least one digit, and a special character.'
    }
}

export type PasswordPolicy = {
    id: number;
    pattern: RegExp;
    text: string;
};

export type ModuleCode = 'F'|'I'|'A'|'C'|'S'|'D';

export const MODULE_CODES: Record<string, ModuleCode> = {
    FINANCE: 'F',
    ITEMS: 'I',
    AGING: 'A',
    CUSTOM: 'C',
    DASHBOARD: 'D',
    SPREADSHEET: 'S'
};

// same as in ModuleDefinition.php
export const MODULE_COLORS = new Map<ModuleCode, string>([
	[MODULE_CODES.FINANCE, '#2C63A1'],
	[MODULE_CODES.ITEMS, '#9A2CA1'],
	[MODULE_CODES.AGING, '#2CA155'],
	[MODULE_CODES.CUSTOM, '#FF9D00'],
	[MODULE_CODES.DASHBOARD, '#54C5D0'],
	[MODULE_CODES.SPREADSHEET, '#449d44'],
]);


export type AccessLogEntity = {
	idz?: string;
	accounting?: number;
	id_accounting_group?: number;
	group_name?: string;
	login_name?: string;
	user_name?: string;
	action?: string;
	date_created?: string;
	email?: string;
	ip?: string;
	host?: string;
	server?: string;
	remark?: string;
	result?: string;
	success?: boolean;
	user_agent?: string;
}

export type AccountingSearchEntity = {
	accounting?: number;
	company?: string;
	id_accounting_group?: number;
	group_name?: string;
	date_visited?: string;
}

export type AccountingSection = {
	id?: number;
	id_accounting_group?: number;
	accounting_from?: number;
	accounting_to?: number;
	type?: string;
	id_server?: number;
	group_name?: string;
	host?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type DimensionInfo = {
	dim_num?: number;
	description?: string;
}

export type Module = {
	module?: string;
	name?: string;
	color?: string;
	type?: string;
	dimensions?: DimensionInfo[];
}

export type EmailLogEntity = {
	server?: string;
	profile?: string;
	mailitem_id?: number;
	send_request_date?: string;
	recipients?: string;
	subject?: string;
	file_attachments?: string;
	sent_status?: string;
	error?: string;
}

export type Embedding = {
	id_embedding?: string;
	accounting?: number;
	id_report?: number;
	old_id_report?: number;
	module?: string;
	public?: boolean;
	readonly?: boolean;
	name?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type JournalEntity = {
	accounting?: number;
	company?: string;
	level?: number;
	timespan?: string;
	server?: string;
	count?: number;
	date?: string;
	error?: number;
	idz?: number;
	id_audit?: number;
	job_name?: string;
	module?: string;
	procedure_name?: string;
	remark?: string;
	run_time?: number;
	table_name?: string;
	size?: number;
}

export type ReportEmail = {
	idz?: number;
	id_embedding?: string;
	id_thread?: number;
	custom_parameters?: string;
	recipient?: string;
	copy_recipient?: string;
	blind_copy_recipient?: string;
	subject?: string;
	body?: string;
	filename?: string;
	freq_type?: number;
	freq_interval?: number;
	start_date?: string;
	end_date?: string;
	last_run?: string;
	next_run?: string;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
	accounting?: number;
	company?: string;
	invalid?: boolean;
	description?: string;
}

export type SsoOidcParams = {
	id_group?: number;
	client_secret?: string;
	settings?: string;
}

export type SsoSamlParams = {
	id_group?: number;
	sp?: string;
	idp?: string;
	security?: string;
	transform?: string;
}